module.exports = __webpack_public_path__ + "static/img/logo.3f22e0c6.png";